import { spacesApi } from '@/api/spacesApi/spacesAPIclient'
import { useQuery } from '@tanstack/react-query'
import { TActivityWithNode, TSession } from '@valuecase/common'

export function useReadGroupedActivities(rootNode: string | undefined, type = 'ALL') {
  const query = useQuery<{
    sessions: TSession[]
    activities: TActivityWithNode[]
  }>(
    ['space-activities', rootNode, type],
    async () => {
      if (!rootNode) {
        return { sessions: [], activities: [] }
      }
      const response = await spacesApi.get(`/activity?rootNode=${rootNode}&type=${type}`)
      return response.data
    },
    {
      enabled: !!rootNode,
    },
  )

  return {
    isLoading: query.isLoading,
    isReloading: query.isRefetching && query.isStale,
    isError: query.isError,
    error: query.error,
    data: query.data,
  }
}
